export default __webpack_public_path__ + "static/media/down.40f90866.svg";